// extracted by mini-css-extract-plugin
export default {"skills":"skills_skills__GU+Mg"};